import { render, staticRenderFns } from "./UpdateSlot.vue?vue&type=template&id=3632257c&scoped=true&"
import script from "./UpdateSlot.vue?vue&type=script&lang=js&"
export * from "./UpdateSlot.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSlot.vue?vue&type=style&index=0&id=3632257c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3632257c",
  null
  
)

export default component.exports